window.ankScl= function(id){
	const trg=document.querySelector("#"+ id);
	const sectionTop=trg.getBoundingClientRect().top;
	const currentPos = window.scrollY;
	const gap = 120;
	const target = sectionTop + currentPos - gap;
	window.scrollTo({top:target,behavior: 'smooth'});
}